import { render, staticRenderFns } from "./DeleteVideo.vue?vue&type=template&id=57426a38&scoped=true"
import script from "./DeleteVideo.vue?vue&type=script&lang=js"
export * from "./DeleteVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57426a38",
  null
  
)

export default component.exports